import React from 'react';

import {
  Create,
  SimpleForm,
  TextInput,
  required,
  ReferenceArrayInput,
  SelectArrayInput,
  SelectInput,
  email,
} from 'react-admin';

import {
  Box,
  Card, CardContent, CardHeader, Divider, Grid,
} from '@mui/material';
import cleaner from '../../utilities/dataProvider/cleaner';

import countries from '../../constants/countries';
import { NationalIdentifierInputFields } from '../../customFields/NationalIdentifier';
import SmartDateInput from '../../customFields/SmartDateInput';

const IndividualCreate = () => (
  <Create transform={cleaner}>
    <Card variant="outlined">
      <CardContent>
        <SimpleForm mode="all" component={Box}>
          <Grid container spacing={6}>
            <Grid
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <TextInput fullWidth validate={required()} source="customId" label="Custom id" />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <TextInput source="firstName" fullWidth />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <TextInput source="lastName" fullWidth />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <SelectInput source="residence" choices={countries} fullWidth />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <ReferenceArrayInput perPage={100} label="Groups" source="groups" reference="groups" filter={{ active: true }}>
                <SelectArrayInput optionText="name" fullWidth />
              </ReferenceArrayInput>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <TextInput source="email" fullWidth validate={[email()]} />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <TextInput source="phoneNumber" fullWidth />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 4,
              }}
            >
              <SmartDateInput source="birthDate" fullWidth />
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 8,
              }}
            >
              <Card variant="outlined">
                <CardHeader
                  sx={{
                    color: 'black',
                    fontWeight: 'bold',
                    flexWrap: 'wrap',
                  }}
                  slotProps={{ title: { variant: 'inherit' } }}
                  title="National identifiers"
                />
                <Divider />
                <CardContent>
                  <NationalIdentifierInputFields />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </SimpleForm>
      </CardContent>
    </Card>
  </Create>
);

export default IndividualCreate;
